/* Centralized page identifiers to avoid magic strings in code */

const PAGES = {
	PRODUCTS: 'products'
};

module.exports = { PAGES };
